<script setup lang="ts">
withDefaults(defineProps<{
    showTitle?: boolean;
}>(), {
    showTitle: true,
});
</script>

<template>
    <app-form-content-layout>
        <h1
            v-if="showTitle"
            class="esignature-complete__headline">
            Your document has been submitted
        </h1>

        <p class="esignature-complete__description">
            We've let your closing team know that you have finished signing the document.
        </p>
        <p class="esignature-complete__description">
            You will be notified once the document has been completed.
        </p>
    </app-form-content-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.esignature-complete {
    &__headline {
        font-size: 1.625rem;
        font-weight: 700;
        line-height: 150%;
        color: $black-high;
        margin: 0 0 1rem 0;
    }

    &__description {
        font-size: 1rem;
        line-height: 150%;
        color: $black-high;
        margin: 0 0 1rem 0;

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
